<template>
  <div v-bind="$attrs" @click="handleOpen">
    <Bars3Icon class="main-mobile-footer-icon" aria-hidden="true" />
    <span class="main-mobile-footer-caption">{{ t('More') }}</span>
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useLocale } from '@/plugins/i18n'

import { useModalsStore } from '@/store/modals'
import {
  Bars3Icon
} from '@heroicons/vue/24/outline'
import MoreDrawer from './MoreDrawer.vue'

type Props = {
  isEmptyApp?: boolean
}

const props = defineProps<Props>()

const { t } = useLocale('layouts.Main')

const modalsStore = useModalsStore()

const handleOpen = () => {
  const modalInstance = modalsStore.init(
    'mobile-footer-more',
    markRaw(MoreDrawer),
  )
  modalInstance?.open(modalsStore.getZIndex(), {
    isEmptyApp: props.isEmptyApp,
  })
}

</script>
